// Shared business policy. Secrets and Stripe IDs are supplied only by the server.
export const FEATURES = {
  food_ai: 'Convierte tus comidas en un registro nutricional práctico.',
  ideal_meal: 'Encuentra un plato que encaje con tus objetivos de hoy.',
  training_change: 'Adapta tu entrenamiento a tu material y a tu siguiente fase.',
  nutrition_cycle: 'Ajusta tus macros a tus días de entrenamiento y descanso.',
  event_compensation: 'Planifica tus comidas alrededor de tus eventos.',
  progress_analysis: 'Entiende tu evolución y orienta tu siguiente fase.',
  progress_report: 'Reúne tu evolución en un informe de progreso personalizado.',
  photo_comparison: 'Compara tus fotografías para observar los cambios.',
  photo_tracking: 'Organiza tu seguimiento fotográfico a lo largo del tiempo.',
  full_history: 'Consulta todo tu recorrido y las tendencias de tu progreso.',
};
export const PLAN_LABELS = { FREE: 'FREE', PRO_MONTHLY: 'PRO MENSUAL', PRO_YEARLY: 'PRO ANUAL', EARLY_ADOPTER: 'EARLY ADOPTER', TRIAL: 'PRO EN PRUEBA' };
const positive = (value, fallback) => Number.isSafeInteger(Number(value)) && Number(value) > 0 ? Number(value) : fallback;
export function monetizationConfig(env = {}) {
  return {
    product: 'RECOMPOSICIÓN PRO', currency: 'eur',
    earlyAdopter: env.EARLY_ADOPTER_ENABLED === 'true',
    trialEnabled: env.PRO_TRIAL_ENABLED === 'true',
    freeHistoryDays: positive(env.FREE_HISTORY_DAYS, 7),
    progressTriggerRecords: positive(env.PROGRESS_TRIGGER_RECORDS, 3),
    experiment: 'default',
    plans: {
      PRO_MONTHLY: { amount: positive(env.PRO_MONTHLY_CENTS, 999), interval: 'month', priceId: env.STRIPE_PRICE_MONTHLY },
      PRO_YEARLY: { amount: positive(env.PRO_YEARLY_CENTS, 6999), interval: 'year', priceId: env.STRIPE_PRICE_YEARLY },
      EARLY_ADOPTER: { amount: positive(env.PRO_EARLY_CENTS, 4999), interval: 'year', priceId: env.STRIPE_PRICE_EARLY },
    },
    limits: { total: positive(env.AI_DAILY_TOTAL, 100), food_ai: positive(env.AI_DAILY_FOOD, 60), ideal_meal: positive(env.AI_DAILY_MEALS, 20), training_change: positive(env.AI_DAILY_TRAINING, 10), progress_report: positive(env.AI_DAILY_REPORTS, 10), progress_analysis: positive(env.AI_DAILY_ANALYSIS, 10) },
  };
}
export function publicConfig(env = {}) {
  const config = monetizationConfig(env);
  return { ...config, plans: Object.fromEntries(Object.entries(config.plans).map(([key, { priceId, ...plan }]) => [key, { ...plan, available: Boolean(priceId) && (key !== 'EARLY_ADOPTER' || config.earlyAdopter) }])) };
}
export function hasPro(subscription, now = Date.now(), trialEnabled = false) {
  if (!subscription || !['PRO_MONTHLY', 'PRO_YEARLY', 'EARLY_ADOPTER'].includes(subscription.subscription_plan)) return false;
  if (subscription.subscription_status === 'trialing') return trialEnabled && Number(subscription.current_period_end) * 1000 > now;
  return subscription.subscription_status === 'active' && Number(subscription.paid_through) * 1000 > now;
}
export const money = cents => new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(cents / 100);
